import { SALES_CAL_NAMESPACE } from '@/config/calCom'
import { getCalApi } from '@calcom/embed-react'
import { useEffect, useRef } from 'react'

/** Initializes the Cal.com embed API once, wherever it is first mounted. */
export function useCalCom() {
	const isInitialized = useRef(false)

	useEffect(() => {
		if (isInitialized.current) {
			return
		}
		;(async function initializeCal(): Promise<void> {
			try {
				const cal = await getCalApi({ namespace: SALES_CAL_NAMESPACE })
				cal('ui', { layout: 'month_view' })
				isInitialized.current = true
			} catch (error) {
				console.error('Error initializing Cal.com:', error)
			}
		})()
	}, [])
}
